import React, { useMemo } from 'react';
import LanguageSelect from '@op/components/FilterCommon/widgets/LanguageSelect';
import { useFilterCondConf } from '@op/hooks/useFilterCondConf';
import { LocaleType } from '@op/types/common';
import './index.scss';

interface LanguageFilterSelectProps {
  gameInfo: any;
  value: string[];
  onChange: (language: string[]) => void;
  lang: LocaleType;
}

/**
 * 语种筛选器 — 包装 FilterCommon 的 LanguageSelect 组件
 * 用于 Hot Event PostContentPanel 中按原文语种筛选主贴/评论
 * 与 TranslateSelect（显示语言切换）完全独立
 */
export default function LanguageFilterSelect({
  gameInfo,
  value,
  onChange,
  lang,
}: LanguageFilterSelectProps) {
  const { region_language } = useFilterCondConf({
    gameInfo,
    needRender: true,
    requestList: [{ key: 'region_language' as any, defaultValue: [] }],
  });

  const filterValue = useMemo(() => ({ language: value }), [value]);

  return (
    <div className="dbo-language-filter-select">
      <LanguageSelect
        lang={lang}
        filterOptions={{ region_language }}
        filterValue={filterValue}
        onChange={(_key: string, data: any) => {
          const isAll = data?.ext?.isAll;
          const language: string[] = data?.value?.language || [];
          // isAll 时传空数组（不筛选），否则传选中的语种
          onChange(isAll ? [] : language);
        }}
      />
    </div>
  );
}
